<!--
// app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchResultsJumbotron.vue
-->
<script setup lang="ts">
import type { Match } from "#shared/match/domain/models/Match";
import { setAliasUrl, slugify } from "#shared/Shared/utils";

type Props = {
  match: Match;
};

const props = defineProps<Props>();
const localePath = useLocalePath();
</script>

<template>
  <div class="flex gap-2 lg:gap-4 items-center justify-center w-full">
    <nuxt-link
      :to="
        localePath({
          name: 'teams-team-teamName',
          params: {
            team: match.participants.homeTeamId,
            teamName: slugify(match.participants.homeTeam?.completeName),
          },
        })
      "
      no-prefetch
      class="flex gap-2 lg:gap-4 justify-end items-center w-full"
    >
      <p class="text-3xl font-bold w-full text-right rtl:text-left hidden lg:block">
        {{ match.participants.homeTeam.completeName }}
      </p>
      <p class="font-bold w-full text-right rtl:text-left block lg:hidden">
        {{ match.participants.homeTeam.shortName }}
      </p>
      <NuxtImg
        :src="setAliasUrl(match.participants.homeTeam?.logo.url)"
        :alt="match.participants.homeTeam?.name || ''"
        class="team-logo-jumbotron"
        width="176"
        height="176"
        sizes="64px sm:176px"
      />
    </nuxt-link>
    <p class="score-penalties">{{ match.scores.homeScoreP }}</p>
    <p class="score">{{ match.scores.homeScore }}</p>

    <div class="relative">
      <svg xmlns="http://www.w3.org/2000/svg" width="42" height="26" viewBox="0 0 42 26" fill="none">
        <path
          d="M8.65979 0.25824H33.3402L42 12.7582L33.3402 25.2582H8.65979L0 12.7582L8.65979 0.25824Z"
          fill="black"
        />
      </svg>
      <p class="text-[10px] w-fit h-fit m-auto absolute left-0 right-0 top-0 bottom-0">VS</p>
    </div>

    <p class="score">{{ match.scores.awayScore }}</p>
    <p class="score-penalties">{{ match.scores.awayScoreP }}</p>
    <nuxt-link
      :to="
        localePath({
          name: 'teams-team-teamName',
          params: {
            team: match.participants.awayTeamId,
            teamName: slugify(match.participants.awayTeam?.completeName),
          },
        })
      "
      no-prefetch
      class="flex gap-2 lg:gap-4 justify-start items-center w-full"
    >
      <NuxtImg
        :src="setAliasUrl(match.participants.awayTeam?.logo.url)"
        :alt="match.participants.awayTeam?.name || ''"
        class="team-logo-jumbotron"
        width="176"
        height="176"
        sizes="64px sm:176px"
      />
      <p class="text-3xl font-bold w-full hidden lg:block">{{ match.participants.awayTeam.completeName }}</p>
      <p class="font-bold w-full block lg:hidden">
        {{ match.participants.awayTeam.shortName }}
      </p>
    </nuxt-link>
  </div>
</template>

<style scoped>
.score {
  @apply font-bold text-4xl lg:text-6xl;
}

.score-penalties {
  @apply text-primary font-bold text-lg lg:text-4xl;
}

.team-logo-jumbotron {
  @apply lg:w-44 lg:h-44 h-16 w-16 lg:max-w-44 lg:max-h-44 object-contain;
}
</style>
